const hasFullName = (attributes) => {
  return {
    getFirstName() {
      return attributes.firstName;
    },
    getFullName() {
      if(attributes.fullName) {
        return attributes.fullName;
      }
      return `${attributes.firstName} ${attributes.lastName} `;
    },
    getFullNameReversed() {
      return `${attributes.lastName} ${attributes.firstName} `;
    },
    getFullNameFor(key) {
      if(!attributes[key]) {
        return `No ${key} set`
      }
      const first = attributes[key].firstName;
      const last = attributes[key].lastName;
      return `${first} ${last}`;
    },
    getLastName() {
      return attributes.lastName;
    },
  };
};

export default hasFullName;
